<script>

import {defineComponent, nextTick, ref} from "vue";
import { QrcodeCanvas } from "qrcode.vue";
import allGiveLogo from "../../../assets/logos/allgive_icon.png";
import {useAnalyticEventStore} from "../../stores/analyticEvents";

export default defineComponent(   {
  name: "QRComponent",
  components: { QrcodeCanvas },
  props: {
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 100,
    },
    foreground: {
      type: String,
      default: "#000000",
    },
    fromDesignHub: {
      type: Boolean,
      default: false,
    },
    modelName: {
      type: String,
      default: "campaign",
    },
    imageSettings: {
      default: () => ({
          src: allGiveLogo,
          width: 25,
          height: 25,
          excavate: true,
      }),
    },
    downloadableImageSettings: {
      default: () => ({
        src: allGiveLogo,
        width: 25*5,
        height: 25*5,
        excavate: true,
      }),
    },
  },
  setup() {
    const downloadableQr = ref(null);
    const downloading = ref(false);
    const analyticEventStore = useAnalyticEventStore();
    return {
      downloadableQr,
      downloading,
      analyticEventStore,
    };
  },
  computed: {
    qrUrl() {
      return `${this.value}?source=qr`;
    }
  },
  methods: {
    async downloadQr() {
      this.downloading = true;
      this.analyticEventStore.logEvent({ action: `${this.modelName}-download-qr-code` });
      await nextTick();
      // Allow time for the logo image to render in the canvas
      await new Promise(resolve => setTimeout(resolve, 200));

      const wrapper = this.downloadableQr;
      if (!wrapper) {
        return;
      }

      const canvas = wrapper.querySelector('canvas');
      if (!canvas) {
        return;
      }

      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "donation-qr.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloading = false;
    },

  }
});
</script>
<template>
  <div
    v-if="downloading"
    ref="downloadableQr"
    class="downloadableQr"
  >
    <qrcode-canvas
      class="downloadable-qr"
      :value="qrUrl"
      :size="500"
      level="H"
      :foreground="foreground"
      :image-settings="downloadableImageSettings"
    />
  </div>
  <div class="flex flex-col items-center">
    <qrcode-canvas
      :value="qrUrl"
      :size="size"
      level="H"
      :foreground="foreground"
      :image-settings="imageSettings"
    />
    <!--    <p-->
    <!--      class="text-center p-2 cursor-pointer download-hover"-->
    <!--      @click="downloadQr"-->
    <!--    >-->
    <!--      <i class="fas fa-download" />-->
    <!--      Download-->
    <!--    </p>-->
    <button
      :class="[
        'text-center p-2 rounded-md text-white cursor-pointer mt-2 button-filled',
        // fromDesignHub ? 'bg-default_primary hover:bg-default_primary_dark w-full' : 'bg-green-800 hover:bg-green-900'
      ]"
      @click="downloadQr"
    >
      <i class="fas fa-download" />
      Download
    </button>
  </div>
</template>



<style scoped lang="scss">
.downloadableQr {
  display: none;
}
p {
  font-size: 0.8rem;
}


</style>
